<!-- =========================================================================================
    Author URL: Martin vicencio
========================================================================================== -->
<template>
  <div id="invoice-page">                     
    <vx-card>
 
 <div class="card mb-3" style="max-width: 1040px;">
  <div class="row g-0">
    <div class="col-md-4">
    
      <a href="#"  @click="abrir_upload()"> 
        
      <img v-show="foto_admin!=''" :src="foto_admin" alt="user_admin" class="img-fluid rounded-start">

      <center> <br><img  v-show="foto_admin==''" :src="require('@/assets/images/profile/user-uploads/'+user04+'.jpg')" alt="user" class="img-fluid rounded">
        </center>
      <!-- <p>  <vs-button style="width: 160px; hight: 20px; padding: 2px;margin: 2px;" class="float-right"  @click="abrir_upload()" >  Cambiar Imagen </vs-button>    </p> -->
      </a>
    </div>

   <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title">Mis Datos</h5>
        <p class="card-text">
           Bienvenido(a) Administrador.
           </p>
           <p class="vx-col w-full">
                   <a href="https://upbicentenario.edu.mx/" target="_blank"><b>Pagina Oficial</b></a><br>
                    <a href="https://upbicentenario.edu.mx/tu-universidad-en-linea/" target="_blank"><b>Procedimientos para tramites y servicios de la UPB</b></a>
                </p>
                  
                         <p style="clear:right;">Puesto: {{admin_detalle['puesto']}}
                          <br>Numero Empleado: {{admin_detalle['num_empleado']}}
                         <br>Nombre: {{admin_detalle['nombres']}} {{admin_detalle['apaterno']}} {{admin_detalle['amaterno']}}
                         <br>Correo: {{admin_detalle['correo']}}</p>
         
        <p class="card-text"><small class="text-muted">Última actualización hace 3 minutos</small></p>
      </div>
    </div>
  </div>
</div>
           <!-- INVOICE METADATA -->                     

        <vs-popup style=""  class="holamundo"  title="Cambiar Imagen:" :active.sync="popupActive_img">
           <div class="row">
               <input type="file" accept="image/jpeg" id="file_img_perfil" ref="file_img_perfil" v-on:change="onChangeFoto()" @click="previsualizar_img_clic()" />
                <br>
                <img v-show="file_img_perfil!=''" id="imagenPrevisualizacion"  width="40%" height="40%" >        
                <br>
                <vs-button style="margin:2px" :disabled="file_img_perfil==''"  @click="post_url()" > Enviar</vs-button>
            </div>
         </vs-popup>
                                   
               
           <!-- INVOICE FOOTER -->
            <div class="invoice__footer text-right p-base">    </div>
        </vx-card>

    </div>
</template>

<script>

export default{
    data() {
        return {
            id: localStorage.getItem('id'),
            // matricula: localStorage.getItem('matricula'),
            admin_detalle: [],
            user04:'user1',
            foto_admin:'',
             popupActive_img:false,
             file_img_perfil: ''
        }
    },
    computed: {

     },
    created() {
        this.getAdmin();


    },
    methods: {

        abrir_upload(){
        this.popupActive_img = true;  
        },
         

        
onChangeFoto(){
  
      var fileName = document.getElementById("file_img_perfil").value;
        var idxDot = fileName.lastIndexOf(".") + 1;
        var extFile = fileName.substr(idxDot, fileName.length).toLowerCase();
        if (extFile=="jpg" || extFile=="jpeg" || extFile=="png"){
            this.file_img_perfil = this.$refs.file_img_perfil.files[0];
                       
        }else{
            alert("¡Solo imagenes jpg/jpeg y png estan permitidas!");
            document.getElementById("file_img_perfil").value=''
        }

      
    },


previsualizar_img_clic(){

              const $file_img_perfil = document.querySelector("#file_img_perfil"),
                $imagenPrevisualizacion = document.querySelector("#imagenPrevisualizacion");

                 // Escuchar cuando cambie
                 file_img_perfil.addEventListener("change", () => {
                   // Los archivos seleccionados, pueden ser muchos o uno
                   const archivos = $file_img_perfil.files;
                   // Si no hay archivos salimos de la función y quitamos la imagen
                   if (!archivos || !archivos.length) {
                     $imagenPrevisualizacion.src = "";
                     return;
                   }
                   // Ahora tomamos el primer archivo, el cual vamos a previsualizar
                   const primerArchivo = archivos[0];
                   // Lo convertimos a un objeto de tipo objectURL
                   const objectURL = URL.createObjectURL(primerArchivo);
                   // Y a la fuente de la imagen le ponemos el objectURL
                     $imagenPrevisualizacion.src = objectURL;
                    
                 });

},

         post_url(){

            let formData = new FormData();
            formData.append('file_img_perfil', this.file_img_perfil);
            // https://cdn.upbicentenario.edu.mx/api/upload_img_perfil_admin/id_usuario

      this.$http.post('upload_img_perfil_admin/'+this.id,
      formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }       
            
      ).then(response => {

         if(response.data.mensaje == '1'){
          //  this.alerta_txt = "se han guardado los datos correctamente";
            this.successUpload();
            this.file_img_perfil='';
             this.popupActive_img = false;  
              //  this.$vs.loading();
              //   this.$vs.loading.close();
                  location.reload();
          
          }else{
             response.data.mensaje;
           }

         });

      // this.$http.post('https://cdn.upbicentenario.edu.mx/api/uploadAdmision/' + this.id,
      //         formData,
      //         {
      //           headers: {
      //             'Content-Type': 'multipart/form-data'
      //           }
      //         }

        },

          successUpload() {
            this.$vs.notify({ color: 'success', title: 'Cargada correctamente', text: 'Lorem ipsum dolor sit amet, consectetur' })
        },
    //  initValues() {
    //   this.name = '';
    //   this.category = 'audio';
    //   this.order_status = 'pending';
    //   this.price = '';
    //   this.$refs.fileUpload.srcs = [];
    //  },
        getAdmin() {
            this.$http.get("catalogos/get_admin/" + this.id).then(
                response => {
                    // console.log(response.data)
                    this.admin_detalle = response.data.administrativo;
                 //   console.log(this);
                 this.foto_admin='https://cdn.upbicentenario.edu.mx/img_admin/'+this.admin_detalle['img'];
                  //  location.reload();
                    
                      // this.$vs.loading.close();

                },
                error => {
                    this.StepError(error);
                }
            );
        },
    },

    components: {}
}
</script>


<style lang="scss" scoped>
.add-new-data-sidebar {
  /deep/ .vs-sidebar--background {
    z-index: 52010;
  }

  /deep/ .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}
</style>